var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepperDivider = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 1,
    viewBox: "0 0 20 1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 0.5,
    x2: 20,
    y2: 0.5,
    stroke: "#D1D5DB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepperDivider);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stepper-divider.7a5bb4df7b6e8f94b3a7bf063a3914d5.svg";